
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Param, SurveyRangeVo, Convert} from "@/js/ParamList";

@Component({
  name: 'table-show-range-body.vue',
})
export default class ShowMeasuringRange extends Vue {
  @Prop()
  paramList !: Param[];
  @Prop()
  skey !: string;

  cloneData(data: any) {
    return JSON.parse(JSON.stringify(data));
  }

  packageSurveyRangeV3(srList: SurveyRangeVo[]) {
    let str = '';
    const strList = [] as any;
    srList.forEach((sr) => {
      let tempStr = '';
      if (sr.lowerLimit == '' && sr.lowerUnit == '' && sr.upperUnit == '' && sr.upperLimit == '') {
        return;
      }
      if(sr.connector == '↴'){
        tempStr += '<br />';
      }

      if(!this.isLine(sr.connector) && sr.connector != '↴'){
        tempStr += sr.connector;
      }
      if (sr.dataType === 'param') {
        tempStr += '<span> ' + sr.paramName + '</span>';
        tempStr += sr.paramItemName;
      } else{
        if(this.isLine(sr.connector)){
          tempStr += '<span class="param-name-hidden"> ' + sr.paramName + '</span>';
        }
        if (sr.dataType === 'paramItem'){
          tempStr += sr.paramItemName;
        }

      }
      if (sr.lowerUnit && sr.upperUnit && sr.lowerUnit == sr.upperUnit && ['×', '～'].indexOf(sr.symbol) > -1) {
        tempStr += '（' + sr.lowerLimit + sr.symbol + sr.upperLimit + '）' + sr.upperUnit + sr.suffix;
      } else {
        tempStr += ' ' + sr.lowerLimit + sr.lowerUnit + sr.symbol + sr.upperLimit + sr.upperUnit + ' ' + sr.suffix;
      }

      strList.push(tempStr);
    });
    str = strList.join("");
    return str;
  }

  packageAccuracyLevelsV3(srList: SurveyRangeVo[]) {
    let str = "";
    if (srList.length === 0) {
      return "";
    }
    if (srList[0].accuracyLevels.length > 0) {
      str = srList[0].accuracyLevels.map((al) => {
        if (al.maxError) {
          return al.maxError;
        }
      }).join("\n");
    }
    return str;
  }

  groupByConnector() {
    let paramList = [];
    if(this.paramList &&  "string" == typeof this.paramList){
      paramList = JSON.parse(this.paramList)
    }else{
      paramList = this.paramList;
    }
    //数据转换
    const surveyRangeList = Convert.paramListToSurveyRangeVo(paramList);
    let groupIndex = 1;
    let list = [] as any;
    let dataList = [] as any;
    for (let i = 0; i < surveyRangeList.length; i++) {
      const data = surveyRangeList[i];
      if (i === 0) {
        list = [data];
        if (i == (surveyRangeList.length - 1)) {
          dataList.push(this.cloneData(list));
        }
        continue;
      }
      //是否占用一整行
      if (this.isLine(data.connector)) {
        dataList.push(this.cloneData(list));
        list = [];
        groupIndex++;
      }
      list.push(data);
      if (i == (surveyRangeList.length - 1)) {
        dataList.push(this.cloneData(list));
        continue;
      }
    }
    return dataList;
  }

  //是否占用一整行
  isLine(connector: string) {
    return connector == '' || connector == '—';
  }
}
